// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3ZEgk","current":"styles_current__Mirik","languageList":"styles_languageList__k0tK6","active":"styles_active__DE14X"};